import { render, staticRenderFns } from "./JeanInformaticaEmpresa.vue?vue&type=template&id=3f1b9b1b&scoped=true"
import script from "./JeanInformaticaEmpresa.vue?vue&type=script&lang=js"
export * from "./JeanInformaticaEmpresa.vue?vue&type=script&lang=js"
import style0 from "./JeanInformaticaEmpresa.vue?vue&type=style&index=0&id=3f1b9b1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b9b1b",
  null
  
)

export default component.exports